module.exports = __webpack_public_path__ + "static/media/PG-Character-Sun-Jar.3346d2e5.png";